export default __webpack_public_path__ + "static/media/rhenus-rt.03d3a468.svg";